// extracted by mini-css-extract-plugin
export default {"wrapper":"quantity-unit_wrapper__Fj-hO","inputContainer":"quantity-unit_inputContainer__C8nfD","input":"quantity-unit_input__ZoUeo","unit":"quantity-unit_unit__kgdyu"};